import { render, staticRenderFns } from "./UpdateWorkspace.vue?vue&type=template&id=302f11b7"
import script from "./UpdateWorkspace.vue?vue&type=script&lang=js"
export * from "./UpdateWorkspace.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports